import { render, staticRenderFns } from "./ShiftsTopRightContainer.vue?vue&type=template&id=67630239&scoped=true&"
import script from "./ShiftsTopRightContainer.vue?vue&type=script&lang=js&"
export * from "./ShiftsTopRightContainer.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsTopRightContainer.vue?vue&type=style&index=0&id=67630239&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67630239",
  null
  
)

export default component.exports